import script from "./sideNav.vue?vue&type=script&setup=true&lang=js"
export * from "./sideNav.vue?vue&type=script&setup=true&lang=js"

import "./sideNav.vue?vue&type=style&index=0&id=1a7e3a7a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a7e3a7a"]])

export default __exports__